import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
// import "./Forms.css";
// import "./RecordPayementForm.css";
import { useParams } from "react-router-dom"; // Example from React Router
import API_URL from '../Config';  // Adjust the path based on your file structure

export default function RecordPaymentForm({ isSidebarExpanded }) {
  const CHEQUE_INPUT_LENGTH = 6;
  const [payment_mode, setPaymentMode] = useState("");
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClient, setSelectedClient] = useState("");
  const [payment_date, setPaymentDate] = useState("");
  const [amount, setAmount] = useState("");
  const [chequeDetails, setChequeDetails] = useState({
    cheque_numbers: Array(CHEQUE_INPUT_LENGTH).fill(""),
    cheque_date: "",
    bank_name: "",
  });
  const inputRefs = useRef([]);

  const [transaction_id, setTransactionId] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const { payment_id } = useParams();
  const handlePaymentModeChange = (e) => {
    setPaymentMode(e.target.value);
  };

  const handleClientChange = (e) => {
    setSelectedClient(e.target.value);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleChequeDetailChange = (e) => {
    const { name, value } = e.target;
    setChequeDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleTransactionIdChange = (e) => {
    setTransactionId(e.target.value);
  };

  const handlePaymentDateChange = (e) => {
    setPaymentDate(e.target.value);
  };

  useEffect(() => {
    const fetchClients = async () => {
      const authKey = localStorage.getItem("authKey");
      try {
        const response = await axios.get(
          `${API_URL}/api/get_client_name`,
          {
            headers: {
              Authorization: `Bearer ${authKey}`,
            },
          }
        );
        setClients(response.data.data);
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch clients");
        setLoading(false);
      }
    };
    fetchClients();
  }, []);

 

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Concatenate the cheque numbers into a single string (e.g., "12333")
    const concatenatedChequeNumbers = chequeDetails.cheque_numbers.join("");

    const paymentData = {
      client_name: selectedClient,
      payment_date,
      payment_mode,
      amount,
      cheque_number: payment_mode === "cheque" ? concatenatedChequeNumbers : "", // Send the concatenated string
      cheque_date: payment_mode === "cheque" ? chequeDetails.cheque_date : null,
      bank_name: payment_mode === "cheque" ? chequeDetails.bank_name : null,
      transaction_id: payment_mode === "online" ? transaction_id : null,
    };

    const authKey = localStorage.getItem("authKey");

    try {
      // Check if payment_id exists (for updating)
      if (payment_id) {
        // Send a PUT request to update the payment
        const response = await axios.put(
          `${API_URL}/api/edit_payment/${payment_id}`,
          paymentData,
          {
            headers: {
              Authorization: `Bearer ${authKey}`,
            },
          }
        );
        setSuccessMessage("Payment updated successfully!");
        setError(""); // Clear any previous errors

        // Clear form fields on success
        setSelectedClient("");
        setPaymentDate("");
        setPaymentMode("");
        setAmount("");
        setChequeDetails({
          cheque_numbers: Array(CHEQUE_INPUT_LENGTH).fill(""),
          cheque_date: "",
          bank_name: "",
        });
        setTransactionId("");
      } else {
        // If payment_id is not available, handle it as a new entry or error as per your requirement
        setError("Payment ID is missing for update");
      }
    } catch (error) {
      setError("Failed to update payment");
      setSuccessMessage("");
      console.error("Error:", error.message);
    }
  };

  useEffect(() => {
    const fetchPaymentDetailsById = async () => {
      try {
        setLoading(true);
        const authKey = localStorage.getItem("authKey");

        if (!authKey) {
          throw new Error("Authentication key not found");
        }

        const response = await axios.get(
          `${API_URL}/api/get_payment_by_id/${payment_id}`,
          {
            headers: { Authorization: authKey },
          }
        );

        const data = response.data?.data;

        if (!data || data.length === 0) {
          throw new Error("No payment details found");
        }

        // Merge the data objects into a single structure
        const mainData = data[0];
        const chequeData = data.find((item) => item.cheque_number) || {};

        // Populate the fields with fetched data
        setPaymentMode(mainData.payment_mode || "");
        setSelectedClient(mainData.client_name || "");
        setPaymentDate(
          new Date(mainData.payment_date).toISOString().split("T")[0] || ""
        );
        setAmount(mainData.amount || "");
        setChequeDetails({
          cheque_numbers: chequeData.cheque_number
            ? chequeData.cheque_number
                .split("")
                .slice(0, CHEQUE_INPUT_LENGTH)
                .concat(
                  Array(
                    Math.max(
                      0,
                      CHEQUE_INPUT_LENGTH - chequeData.cheque_number.length
                    )
                  ).fill("")
                )
            : Array(CHEQUE_INPUT_LENGTH).fill(""),
          cheque_date: chequeData.cheque_date
            ? new Date(chequeData.cheque_date).toISOString().split("T")[0]
            : "",
          bank_name: chequeData.bank_name || "",
        });
        setError("");
      } catch (error) {
        console.error("Error fetching payment details:", error.message);
        setError("Failed to fetch payment details");
      } finally {
        setLoading(false);
      }
    };

    if (payment_id) {
      fetchPaymentDetailsById();
    }
  }, [payment_id]);

  const handleChequeChange = (e, index) => {
    const rawValue = (e.target.value || "").replace(/\D/g, "");
    const maxLength = chequeDetails.cheque_numbers.length;

    if (!rawValue) {
      setChequeDetails((prev) => {
        const updatedChequeNumbers = [...prev.cheque_numbers];
        updatedChequeNumbers[index] = "";
        return { ...prev, cheque_numbers: updatedChequeNumbers };
      });
      return;
    }

    setChequeDetails((prev) => {
      const updatedChequeNumbers = [...prev.cheque_numbers];

      if (rawValue.length === 1) {
        updatedChequeNumbers[index] = rawValue;
      } else {
        for (
          let i = index, j = 0;
          i < maxLength && j < rawValue.length;
          i += 1, j += 1
        ) {
          updatedChequeNumbers[i] = rawValue[j];
        }
      }

      return { ...prev, cheque_numbers: updatedChequeNumbers };
    });

    const nextIndex =
      rawValue.length > 1
        ? Math.min(index + rawValue.length, maxLength - 1)
        : Math.min(index + 1, maxLength - 1);
    inputRefs.current[nextIndex]?.focus();
  };

  const handleChequeKeyDown = (e, index) => {
    const maxLength = chequeDetails.cheque_numbers.length;
    const currentValue = chequeDetails.cheque_numbers[index] || "";

    if (e.key === "Backspace") {
      e.preventDefault();

      setChequeDetails((prev) => {
        const updatedChequeNumbers = [...prev.cheque_numbers];

        if (updatedChequeNumbers[index]) {
          updatedChequeNumbers[index] = "";
          return { ...prev, cheque_numbers: updatedChequeNumbers };
        }

        if (index > 0) {
          updatedChequeNumbers[index - 1] = "";
        }

        return { ...prev, cheque_numbers: updatedChequeNumbers };
      });

      if (!currentValue && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
      return;
    }

    if (e.key === "ArrowLeft") {
      e.preventDefault();
      if (index > 0) inputRefs.current[index - 1]?.focus();
      return;
    }

    if (e.key === "ArrowRight") {
      e.preventDefault();
      if (index < maxLength - 1) inputRefs.current[index + 1]?.focus();
      return;
    }
  };

  const handleChequePaste = (e, index) => {
    e.preventDefault();
    const pastedValue = (e.clipboardData.getData("text") || "").replace(
      /\D/g,
      ""
    );
    if (!pastedValue) return;

    const maxLength = chequeDetails.cheque_numbers.length;
    let lastFilledIndex = index;

    setChequeDetails((prev) => {
      const updatedChequeNumbers = [...prev.cheque_numbers];

      for (
        let i = index, j = 0;
        i < maxLength && j < pastedValue.length;
        i += 1, j += 1
      ) {
        updatedChequeNumbers[i] = pastedValue[j];
        lastFilledIndex = i;
      }

      return { ...prev, cheque_numbers: updatedChequeNumbers };
    });

    inputRefs.current[lastFilledIndex]?.focus();
  };

  return (
    <div
      className={`table-container ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content form-main-body">
        <h1 className="form-title jost-bold">Edit Record</h1>
        <div className="form-body">
          <form onSubmit={handleSubmit}>
            <div className="form-body-container">
              <div className="form-group">
                <label className="form-label">
                  Client
                  <span className="required">*</span>
                </label>
                {loading ? (
                  <p>Loading clients...</p>
                ) : error ? (
                  <p>{error}</p>
                ) : (
                  <select
                    value={selectedClient}
                    onChange={handleClientChange}
                    className="select-field record-field"
                  >
                    <option value="" disabled>
                      Select Client
                    </option>
                    {clients.map((client) => (
                      <option
                        key={client.client_name}
                        value={client.client_name}
                      >
                        {client.client_name}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="form-group">
                <label className="form-label jost-regular">
                  Payment Date <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <input
                    type="date"
                    className="input-field"
                    value={payment_date}
                    onChange={handlePaymentDateChange}
                    required
                  />
                </div>
              </div>

              {/* <div className="form-group">
                <label className="form-label jost-regular">
                  Payment Type <span className="required">*</span>
                </label>
                <div className="payment-radio">
                  <div className="form-inputs">
                    <div className="payment-type">
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMode"
                          value="online"
                          onChange={handlePaymentModeChange}
                          required
                        />
                        <span className="radio-text">Online</span>
                      </label>

                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMode"
                          value="cash"
                          onChange={handlePaymentModeChange}
                          required
                        />
                        <span className="radio-text">Cash</span>
                      </label>

                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMode"
                          value="cheque"
                          onChange={handlePaymentModeChange}
                          required
                        />
                        <span className="radio-text">Cheque</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="form-group">
                <label className="form-label jost-regular">
                  Payment Type <span className="required">*</span>
                </label>
                <div className="payment-radio">
                  <div className="form-inputs">
                    <div className="payment-type">
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMode"
                          value="online"
                          checked={payment_mode === "online"} // Bind checked to payment_mode
                          onChange={handlePaymentModeChange}
                          required
                        />
                        <span className="radio-text">Online</span>
                      </label>

                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMode"
                          value="cash"
                          checked={payment_mode === "cash"} // Bind checked to payment_mode
                          onChange={handlePaymentModeChange}
                          required
                        />
                        <span className="radio-text">Cash</span>
                      </label>

                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMode"
                          value="cheque"
                          checked={payment_mode === "cheque"} // Bind checked to payment_mode
                          onChange={handlePaymentModeChange}
                          required
                        />
                        <span className="radio-text">Cheque</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label jost-regular"></label>
                <div className="payment-condition">
                  {payment_mode === "cheque" && (
                    <>
                      <div className="form-group-1 cheque-payment">
                        <label className="form-labels jost-regular">
                          Cheque No <span className="required">*</span>
                        </label>
                        <div className="form-inputs">
                          {chequeDetails.cheque_numbers.map((number, index) => (
                            <input
                              key={index}
                              type="text"
                              className="input-field-record"
                              value={number}
                              onChange={(e) => handleChequeChange(e, index)}
                              onKeyDown={(e) => handleChequeKeyDown(e, index)}
                              onPaste={(e) => handleChequePaste(e, index)}
                              onFocus={(e) => e.target.select()}
                              maxLength={1}
                              inputMode="numeric"
                              autoComplete="off"
                              required
                              ref={(el) => (inputRefs.current[index] = el)}
                            />
                          ))}
                        </div>
                      </div>

                      <div className="form-group-1">
                        <label className="form-labels jost-regular"></label>
                        <div className="form-inputs">
                          <input
                            type="text"
                            className="input-field bankName"
                            name="bank_name"
                            value={chequeDetails.bank_name}
                            onChange={handleChequeDetailChange}
                            required
                            placeholder="enter bank name"
                          />
                        </div>
                      </div>

                      <div className="form-group-1">
                        <label className="form-labels jost-regular"></label>
                        <div className="form-inputs">
                          <input
                            type="date"
                            className="input-field bankName"
                            name="cheque_date"
                            value={chequeDetails.cheque_date}
                            onChange={handleChequeDetailChange}
                            required
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {payment_mode === "online" && (
                    <div className="form-group-1">
                      <label className="form-label jost-regular"></label>
                      <div className="form-inputs">
                        <input
                          type="text"
                          className="input-field bankName"
                          value={transaction_id}
                          onChange={handleTransactionIdChange}
                          required
                          placeholder="Enter Your TransactionID"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label className="form-label jost-regular">
                  Amount <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <input
                    type="text"
                    className="input-field"
                    value={amount}
                    onChange={handleAmountChange}
                    required
                  />
                </div>
              </div>

              <div className="button-group">
                <button type="button" className="btn btn-cancel">
                  CANCEL
                </button>
                <button type="submit" className="btn btn-save">
                  SAVE
                </button>
              </div>
            </div>
          </form>
          {successMessage && (
            <p className="success-message">{successMessage}</p>
          )}
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
    </div>
  );
}
